import { NgModule } from '@angular/core';

import { BasePageMetaResolver, ContentPageMetaResolver, provideConfig } from '@spartacus/core';
import { SeoMetaService } from '@spartacus/storefront';

import { PAGE_META_CONFIG } from '@app-modules/page-meta/configs';
import { DpBasePageMetaResolver, DpContentPageMetaResolver } from '@app-modules/page-meta/resolvers';
import { DpSeoMetaService } from '@app-modules/page-meta/services';

@NgModule({
  providers: [
    provideConfig(PAGE_META_CONFIG),
    { provide: BasePageMetaResolver, useClass: DpBasePageMetaResolver },
    { provide: ContentPageMetaResolver, useClass: DpContentPageMetaResolver },
    { provide: DpContentPageMetaResolver, useExisting: DpContentPageMetaResolver },
    { provide: SeoMetaService, useClass: DpSeoMetaService }
  ]
})
export class DpPageMetaModule {}
